import $ from "cash-dom";
import { CarsForSaleController } from "./CarsForSaleController";
import { CarComponent, getAPIRequest } from "./Helpers";

export class ElectricVehicles extends CarsForSaleController {
  pageType = "ElectricVehicles";

  public filter(): void {
    this.removeErrorAlert();
    this.getSortedCards();
    this.getDynamicFilters();
  }

  public sortBy(params) {
    if (this.page > 1) {
      return this.redirectTo(null, params);
    }
    this.getSortedCards();
  }

  private getSortedCards() {
    let carList = $("#car-list");
    this.setLoadingCards(carList);
    this.getCars()
      .then((jsonData) => {
        carList.empty();
        jsonData.carComponents.forEach((carComponent) => {
          carList.append(carComponent);
        });
        $("nav.pagination").html(jsonData.pagination);
      })
      .catch((error) => {
        console.log(error);
        var now = new Date();
        now.setTime(now.getTime() + 5 * 1000);
        document.cookie =
          "error_notification=true;expires=" + now.toUTCString() + ";";
        this.redirectTo(null, null);
      });
  }

  private async getCars() {
    let paramsString = new URLSearchParams(this.queryString.toString());
    paramsString.set("page", paramsString.get("page") ?? "1");
    paramsString.set("page_type", this.pageType);
    let request = getAPIRequest("cars", paramsString.toString());
    return fetch(request)
      .then((res) => res.json())
      .then((res) => {
        return res as CarComponent;
      });
  }

  public getDynamicFilters() {
    let paramsString = new URLSearchParams(this.queryString.toString());
    paramsString.set("page_type", this.pageType);
    this.getFilters(paramsString).then((filters) => {
      this.queryString.forEach((value: string, key: string) => {
        if ($(`input[name="${key}"]`).attr("type") == "checkbox") {
          $(`input[name="${key}"][value="${value}"]`).prop("checked", true);
        }
      });
    });
  }

  private async getFilters(paramsString) {
    let request = getAPIRequest("filters", paramsString.toString());
    return fetch(request)
      .then((res) => res.json())
      .then((res) => {
        return res.filters;
      });
  }
}
